import { axiosInstance } from '@/lib/utils';
import type {
  ShippingMethodCreationPayload,
  ShippingMethodModificationPayload,
} from './payload';
import { endpoints } from '@/api';
import type { ShippingMethod, RequestResponse } from '@/types';

export const createShippingMethod = async (
  payload: ShippingMethodCreationPayload
) => {
  const response = await axiosInstance.post<RequestResponse<ShippingMethod>>(
    endpoints.shipping,
    payload
  );
  return response.data;
};

export const updateShippingMethod = async ({
  id,
  ...payload
}: ShippingMethodModificationPayload) => {
  const response = await axiosInstance.patch<RequestResponse<ShippingMethod>>(
    `${endpoints.shipping}/${id}`,
    payload
  );
  return response.data;
};

export const deleteShippingMethod = async (id: number) => {
  const response = await axiosInstance.delete<RequestResponse<ShippingMethod>>(
    `${endpoints.shipping}/${id}`
  );
  return response.data;
};
